// Debugging confirmation
console.log('✅ General Always Static Page Builder loaded successfully!');

// Dynamically import the necessary modules when needed
async function loadGeneralStaticPageDependencies() {
  console.log('🚀 Dynamically loading general static page dependencies...');
  const [
    // { getRegularPageLayoutContentByPageName },
    { buildMasterPageByMasterLayoutBuildManager },
  ] = await Promise.all([
    import('../js/build-manager-utils.js'),
    import('../js/build-manager-master-pages.js'),
  ]);

  return {
    //  getRegularPageLayoutContentByPageName,
    buildMasterPageByMasterLayoutBuildManager,
  };
}

// General Always Static Page Builder
export async function buildContentGeneralAlwaysStaticBuilder(page) {
  console.log(`🏗️ General Always Static Page Builder - Building Static Content: page: ${page}`);

  try {
    // Dynamically load the necessary functions
    const {
      //  getRegularPageLayoutContentByPageName,
      buildMasterPageByMasterLayoutBuildManager,
    } = await loadGeneralStaticPageDependencies();

    // Build the master page layout
    let masterPageLayoutContent = await buildMasterPageByMasterLayoutBuildManager(
      'master-layout-blank'
    );

    // Get the page layout content
    let regularPageLayoutContent = ' fyi no more static content'; // await getRegularPageLayoutContentByPageName(page);

    // Replace content placeholder with actual content
    let layoutContent = masterPageLayoutContent.replace(
      '{{{ content }}}',
      regularPageLayoutContent
    );

    console.log(`🔄 General Always Static Page Builder - Content Built Successfully`);
    return layoutContent;
  } catch (error) {
    console.error('❌ Error building general static page content:', error);
    return 'Error loading general static page content.';
  }
}
